import { ExternalLocationOption } from '@oh-main-modules/global/modules/Locations/shared/components/ExternalLocationsAutocomplete';
import {
  FIELD_NAMES as LOCATION_FIELD_NAMES,
  initialValues as mainInitialValues,
  LocationFormParams as MainLocationFormParams,
} from '../../../../../../../../oh-main/web/frontend/global/modules/Locations/pages/LocationBuilder/consts';

export const FIELD_NAMES = {
  ...LOCATION_FIELD_NAMES,
  MAPBOX_LOCATION: 'mapbox_location',
} as const;

export interface LocationFormParams extends MainLocationFormParams {
  mapbox_location: ExternalLocationOption | null;
}

export const initialValues: LocationFormParams = {
  ...mainInitialValues,
  mapbox_location: null,
};

